export default __webpack_public_path__ + "static/media/ketupak_ribbon.0b37da9c.png";